
		<div *ngIf="!OBJ_form_control?.pristine">
			<div *ngFor="let warning of field_config.warnings">
				<span class="tig-hint" *ngIf="warning.type == 'minLength' && OBJ_form_control?.value.length <= warning.value" >
				  {{ 'oWarning.sMinlength'|translate:{ value: warning.value} }}
				</span>
				<span class="tig-hint" *ngIf="warning.type == 'maxLength' && OBJ_form_control?.value.length >= warning.value" >
				  {{ 'oWarning.sMaxlength'|translate:{ value: warning.value} }}
				</span>
			</div>
		</div>
  